<form [formGroup]="formulario" (ngSubmit)="$event.preventDefault()">
  <div class="row">
    <div class="col-12 col-md-1">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>ID</mat-label>
        <input matInput formControlName="id" readonly>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Segmento</mat-label>
        <mat-select formControlName="segmento" (selectionChange)="aoMudarSegmento()">
          <mat-option *ngFor="let segmento of segmentos" [value]="segmento.codigo">
            {{ segmento.nome }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-3">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Parceiro</mat-label>
        <mat-select formControlName="parceiro" [compareWith]="compararCampos">
          <mat-option [value]="INTERNO">Interno</mat-option>
          <mat-option *ngFor="let parceiro of parceirosDoSegmento" [value]="parceiro">
            {{ parceiro.razaoSocial }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Usuário</mat-label>
        <input matInput style="text-transform: uppercase;" formControlName="usuario">
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Aberto por</mat-label>
        <input matInput style="text-transform: uppercase;" formControlName="abertoPor" readonly>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Prioridade</mat-label>
        <mat-select formControlName="prioridade" (selectionChange)="definirDataPrevisao.emit()">
          <mat-option *ngFor="let prioridade of prioridades" [value]="prioridade">
            {{ getDescricaoPrioridade(prioridade) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Data Abertura</mat-label>
        <input matInput [matDatepicker]="pickerAbertura" formControlName="dataCriacao" readonly>
        <mat-datepicker #pickerAbertura></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Categoria</mat-label>
        <mat-select formControlName="tipoTicket" (selectionChange)="definirDataPrevisao.emit()">
          <mat-option *ngFor="let categoria of tipoTickets" [value]="categoria">
            {{ getDescricaoTipoTicket(categoria) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Previsão de Entrega</mat-label>
        <input matInput [matDatepicker]="pickerPrevisao" formControlName="dataPrevisaoEntrega" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerPrevisao"></mat-datepicker-toggle>
        <mat-datepicker #pickerPrevisao></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Atribuir a</mat-label>
        <mat-select formControlName="responsavelSuporte" [compareWith]="compararCampos">
          <mat-option *ngFor="let atribuido of atribuicoes" [value]="atribuido">
            {{ atribuido.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let st of status" [value]="st">
            {{ getDescricaoStatusTicket(st) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Tempo estimado (h)</mat-label>
        <input matInput type="number" min="0" step="0.5" formControlName="tempoEstimadoHoras"
               [readonly]="tempoEstimadoBloqueado">
        <span matSuffix>h</span>
        <mat-icon matSuffix *ngIf="tempoEstimadoBloqueado"
                  matTooltip="Bloqueado após entrar em desenvolvimento">lock</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-12">
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Assunto</mat-label>
        <input matInput formControlName="menu">
      </mat-form-field>
    </div>
    <div class="col-12 col-md-12">
      <app-rich-text-editor formControlName="texto" label="Descrição"
        placeholder="Descreva a demanda: passos, contexto, prints e pontos importantes...">
      </app-rich-text-editor>
    </div>
    <div class="col-12 col-md-12" style="padding-bottom: 30px;">
      <mat-label>Anexos</mat-label>
      <div class="upload-container" (click)="fileInput.click()" (drop)="soltarArquivos.emit($event)"
        (dragover)="arrastarSobre.emit($event)" (dragleave)="sairDoArrasto.emit($event)"
        [class.drag-over]="isDragOver">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text">Arraste arquivos aqui ou <span>clique para selecionar</span></p>
        <p class="upload-info" style="font-size: 0.8em; color: gray;">
          Qualquer formato (imagem, PDF, vídeo, áudio, etc.). Tamanho máximo: 25 MB.
        </p>
        <input #fileInput type="file" hidden multiple (change)="selecionarArquivos.emit($event)" />
      </div>
      <div class="uploaded-files" *ngIf="uploadedFiles.length > 0">
        <div class="uploaded-file" *ngFor="let file of uploadedFiles; let i = index">
          <div class="uploaded-file__preview" [class.is-clicavel]="isImageFile(file.name)"
            (click)="abrirPreview(file)">
            <img *ngIf="isImageFile(file.name)" [src]="file.preview" alt="{{ file.name }}">
            <mat-icon *ngIf="!isImageFile(file.name)" class="uploaded-file__doc-icon">insert_drive_file</mat-icon>
            <div class="uploaded-file__overlay" *ngIf="isImageFile(file.name)">
              <mat-icon>zoom_in</mat-icon>
              <span>Visualizar</span>
            </div>
          </div>
          <div class="uploaded-file__info">
            <span class="file-name" title="{{ file.name }}">{{ file.name }}</span>
            <span class="file-size" *ngIf="formatarTamanho(file)">{{ formatarTamanho(file) }}</span>
          </div>
          <div class="uploaded-file__acoes">
            <button type="button" mat-icon-button color="primary" matTooltip="Baixar"
              (click)="baixarArquivo.emit({ file, index: i })">
              <mat-icon>download</mat-icon>
            </button>
            <button type="button" mat-icon-button color="warn" matTooltip="Remover" (click)="removerArquivo.emit(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="lightbox" *ngIf="imagemAmpliada" (click)="fecharPreview()">
    <div class="lightbox__conteudo" (click)="$event.stopPropagation()">
      <div class="lightbox__barra">
        <span class="lightbox__nome" title="{{ nomeImagemAmpliada }}">{{ nomeImagemAmpliada }}</span>
        <button type="button" mat-icon-button class="lightbox__fechar" (click)="fecharPreview()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="lightbox__imagem">
        <img [src]="imagemAmpliada" alt="{{ nomeImagemAmpliada }}">
      </div>
    </div>
  </div>
  <div class="row justify-content-between">
    <div class="col-12 col-md-6 d-flex align-items-center gap-2">
      <button type="button" (click)="limpar.emit()" mat-stroked-button>
        <mat-icon>insert_drive_file</mat-icon> Limpar
      </button>
      <mat-checkbox formControlName="apresentarParceiroTicket" color="primary">
        Apresentar Ticket para Parceiro
      </mat-checkbox>
    </div>
  </div>
</form>
